<!--
 * @Description: 产品概述
 * @Author: youme
 * @LastEditors: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2020-06-12 13:02:14
 * @LastEditTime: 2024-05-29 09:10:30
-->
<template>
  <Container>
    <div class="product-body">
      <flank-nav>
        <div class="label-title">概述</div>
        <flank-checkbox name="chose" label="产品概述" value="产品概述" />
        <flank-checkbox name="chose" label="企业价值" :on-change="() => handleJumpByUrl('/companyvalue')" />
        <div class="label-down">
          <div>销售热线：</div>
          <div>15754006669</div>
          <div>0411-39516699</div>
          <div style="margin-top: 24px">售后服务：</div>
          <div>15754006667</div>
          <div>0411-39516676</div>
        </div>
        <div class="label-foot" @click="handleJumpByUrl('/contact')">联系我们</div>
      </flank-nav>
      <img class="banner hidden-md-and-down" :src="banner" alt="banner">
      <img class="banner hidden-lg-and-up" :src="bannerPhone" alt="bannerPhone">

      <div class="product-item">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span: 18, offset: 6}">
              <div class="item-title">
                <img :src="momTitle" alt="momTitle">
                <div class="title">HSMOM</div>
              </div>
            </Cell>
            <Cell :lg="{span: 18, offset: 6}" class="normal-text">
              HAOSMART平台作为连接底层车间与企业管理系统之间的桥梁，HSMOM产品在利用虚拟化容器技术的基础上，集成了HSMES制造执行系统、仓储管理系统、HSEMS能源管理系统、HSQMS质量管理统、HSEAM设备管理等核心子系统。涵盖制造企业计划、物流、生产、质量、设备、资产、能源、运营八大工作领域，集制造执行与工程运营于一体，将制造企业的人、机、料、法、环等生产要素有机结合在一起，帮助企业实现高效协同、精益管理、持续改进。
            </Cell>
            <Cell :lg="{span: 7, offset: 6}" class="product-item-img">
              <div class="item-text">高效协同、精益管理</div>
              <div class="item-text">为您打造数字化运营智能工厂</div>
              <Button type="primary" @click="handleJumpByUrl('/product-mom')">了解详情</Button>
            </Cell>
            <Cell :lg="11" class="product-item-img hidden-md-and-down">
              <img :src="mom" alt="mom">
            </Cell>
          </Row>
        </div>
      </div>

      <div class="product-item">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span: 18, offset: 6}">
              <div class="item-title special">
                <img :src="MES" alt="MES">
                <div class="title">HSMES</div>
                <div class="horizontal" />
              </div>
            </Cell>
            <Cell :lg="{span: 18, offset: 6}" class="normal-text">
              作为智能制造的中枢神经，智源MES系统依靠自主研发的HAOSMART平台，利用条码、RFID等物联网技术对所有的生产要素进行科学的数字化定义，帮助企业完成从“制造”到“智造”的华丽转型。智源MES系统通过实时性数据采集、汇总、共享、分析，规范生产过程控制、提高生产信息透明程度、缩短生产准备时间、提高生产执行管理效率、提高产品质量，最终使企业高效有序地运行。
            </Cell>
            <Cell :lg="18" class="product-item-img hidden-md-and-down">
              <img :src="mes" alt="mes">
            </Cell>
            <Cell :lg="6" class="product-item-img product-item-right">
              <div class="item-text">从“制造”到“智造”</div>
              <div class="item-text">只差一个HSMES</div>
              <div class="item-text">生产制造执行系统</div>
              <div class="item-text">让您随时随地掌控生产</div>
              <Button type="primary" @click="handleJumpByUrl('/product-mes')">了解详情</Button>
            </Cell>
          </Row>
        </div>
      </div>

      <div class="product-item">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span: 18, offset: 6}">
              <div class="item-title special">
                <img :src="EMS" alt="EMS">
                <div class="title">HSEMS</div>
                <div class="horizontal" />
              </div>
            </Cell>
            <Cell :lg="{span: 18, offset: 6}" class="normal-text">
              智源EMS作为工程自动化和信息化的重要组成部分，对企业内的水、电、气等能源进行数据采集、实时监控、故障报警、统计分析，实时准确地掌握企业能耗情况，促进能源输配和消耗的管控集成化。借此优化企业能源平衡、降低单位产品能耗、提高环保质量，与此同时，利用实时客观的数据帮助管理者编制能源计划、管理能源质量、分析事故原因、处理解决能耗问题，真正实现企业绿色生产的目标。
            </Cell>
            <Cell :lg="{span: 7, offset: 6}" class="product-item-img">
              <div class="item-text">低能耗高产出</div>
              <div class="item-text">HSEMS是您的能源新管家</div>
              <Button type="primary" @click="handleJumpByUrl('/product-ems')">了解详情</Button>
            </Cell>
            <Cell :lg="11" class="product-item-img hidden-md-and-down">
              <img :src="ems" alt="ems">
            </Cell>
          </Row>
        </div>
      </div>

      <div class="product-item">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span: 18, offset: 6}">
              <div class="item-title special">
                <img :src="WMS" alt="WMS">
                <div class="title">HSWMS</div>
                <div class="horizontal" />
              </div>
            </Cell>
            <Cell :lg="{span: 18, offset: 6}" class="normal-text">
              作为传统ERP仓储功能的衍生系统，智源WMS利用RFID射频、AGV小车等技术手段，帮助企业重新梳理仓储流程，打造迎合时代发展的信息化仓储管理新形态。为多货多仓的企业实现智能化库房管理、系统化仓储管理、透明化备料管理、自动化运输管理。同时，智源WMS系统支持与企业原有的上下游信息管理系统无缝对接，做到数据实时同步采集传送，信息零丢失，为管理者提供完备的仓储状态。
            </Cell>
            <Cell :lg="18" class="product-item-img hidden-md-and-down">
              <img :src="wms" alt="wms">
            </Cell>
            <Cell :lg="6" class="product-item-img product-item-right">
              <div class="item-text">手机在手</div>
              <div class="item-text">仓储我有</div>
              <div class="item-text">HSWMS是您的仓库管家</div>
              <Button type="primary" @click="handleJumpByUrl('/product-wms')">了解详情</Button>
            </Cell>
          </Row>
        </div>
      </div>

      <div class="product-item">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span: 18, offset: 6}">
              <div class="item-title special">
                <img :src="QMS" alt="QMS">
                <div class="title">HSQMS</div>
                <div class="horizontal" />
              </div>
            </Cell>
            <Cell :lg="{span: 18, offset: 6}" class="normal-text">
              智源QMS把控每道工序质量数据的采集、监控和预警，到成品下线的检验、再到成品发货前的质量报告、成品售后问题管理及成品售后
              入库的质量问题分析，形成全流程的闭环，减少数据孤岛。
            </Cell>
            <Cell :lg="{span: 7, offset: 6}" class="product-item-img">
              <div class="item-text">一键智控</div>
              <div class="item-text">告别纸质记录</div>
              <div class="item-text">HSQMS让质量无忧</div>
              <Button type="primary" @click="handleJumpByUrl('/product-qms')">了解详情</Button>
            </Cell>
            <Cell :lg="11" class="product-item-img hidden-md-and-down">
              <img :src="qms" alt="qms">
            </Cell>
          </Row>
        </div>
      </div>

      <div class="product-item last-item">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span: 18, offset: 6}">
              <div class="item-title special">
                <img :src="EAM" alt="EAM">
                <div class="title">HSEAM</div>
                <div class="horizontal" />
              </div>
            </Cell>
            <Cell :lg="{span: 18, offset: 6}" class="normal-text">
              智源EAM构建了完整资产运营管理体系，覆盖传统的维修、保养、点检等预防性管理手段。除此之外，基于知识图谱、AI的故障诊断专
              家系统、手机移动端应用、多场景需求自由配置、个性化报表等功能，大幅增强了设备管理的易用性、功能性、灵活性。
            </Cell>
            <Cell :lg="18" class="product-item-img hidden-md-and-down">
              <img :src="eam" alt="eam">
            </Cell>
            <Cell :lg="6" class="product-item-img product-item-right">
              <div class="item-text">持续守护设备资产</div>
              <div class="item-text">HSEAM开启设备管理新时代</div>
              <Button type="primary" @click="handleJumpByUrl('/product-eam')">了解详情</Button>
            </Cell>
          </Row>
        </div>
      </div>
      <div class="foot-up hidden-md-and-down">
        <div class="container">
          <Row :gutter="24">
            <Cell :lg="{span:12, offset:6}">
              <div class="text-position">
                有问题吗？<br>
                我们的销售代表会为您解答。
              </div>
              <div class="item-text">您可以联系我们</div>
              <div class="item-text">销售热线：15754006669/0411-39516699</div>
              <div class="item-text">售后服务：15754006667/0411-39516676</div>
              <div class="item-text">您还可以发送邮件至market@haosen.com.cn</div>
              <div class="item-text">进行咨询</div>
              <Button @click="handleJumpByUrl('/contact')">联系我们</Button>
            </Cell>
            <Cell :lg="{span:6}" style="height: 0">
              <img :src="person" alt="person">
            </Cell>
          </Row>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/Container'
import FlankNav from '@/components/FlankNav'
import FlankCheckbox from '@/components/FlankCheckbox'
import mes from '@/assets/product/MES.png'
import ems from '@/assets/product/EMS.png'
import wms from '@/assets/product/WMS.png'
import mom from '@/assets/product/MOM.png'
import eam from '@/assets/product/EAM.png'
import qms from '@/assets/productQMS/pc03.png'
import banner from '@/assets/product/banner.jpg'
import bannerPhone from '@/assets/product/bannerPhone.jpg'
import person from '@/assets/product/person.png'
import { Row, Col, Button } from 'element-ui'
import EMS from '@/assets/home/EMS.png'
import MES from '@/assets/home/MES.png'
import WMS from '@/assets/home/WMS.png'
import EAM from '@/assets/home/EAM.png'
import QMS from '@/assets/home/QMS.png'
import momTitle from '@/assets/product/momTitle.png'

export default {
  name: 'Product',
  components: { Row, 'Cell': Col, Button, Container, FlankNav, FlankCheckbox },
  data: function() {
    return {
      ems,
      mes,
      wms,
      mom,
      qms,
      eam,
      EMS,
      WMS,
      MES,
      QMS,
      EAM,
      momTitle,
      person,
      banner,
      bannerPhone
    }
  },
  methods: {
    handleJumpByUrl(url) {
      this.$router.push({ path: url })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.product-body {
  position: relative;
  .banner {
    position: relative;
    left: 50%;
    margin-left: -960px;
  }
  .label-title {
    padding: 0 0 50px 30px;
  }
  .label-down {
    margin-top: 106px;
    padding-left: 30px;
    line-height: 26px;
  }
  .label-foot {
    margin-top: 34px;
    padding-left: 30px;
    color: #075d99;
    padding-bottom: 30px;
    cursor: pointer;
  }
  .product-item {
    margin-top: 90px;
    line-height: 32px;
    .item-title {
      display: flex;
      align-items: center;
      padding-bottom: 40px;
      position: relative;
      img {
        height: 80px;
        margin-right: 30px;
      }
      &.special {
        position: relative;
        padding-top: 60px;
      }
      .horizontal {
        position: absolute;
        width: 112px;
        height: 2px;
        background-color: #c6c6c6;
        top: 0;
      }
      .title {
        color:#3e3892;
        padding-bottom: 0;
      }
    }
    .product-item-img{
      padding-top:78px;
      /deep/ .el-button {
        margin-top: 52px;
      }
      .item-text{
        @include normalText;
      }
    }
    .show-img {
      width: 100%;
    }
    .product-item-right{
      text-align: right;
    }
  }
  .foot-up{
    margin-top: 90px;
    height: 595px;
    background-color: #f8fafd;
    .text-position {
      @include title;
      color: #333;
      font-weight: bolder;
      line-height: 60px;
      padding-top: 74px;
    }
    .item-text{
      @include normalText;
      line-height: 32px;
      color:#333;
    }
    /deep/ .el-button {
      margin-top: 86px;
    }
    img{
      margin-top: -44px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .product-body {
    .banner {
      width: 100%;
      left: 0;
      margin-left: 0;
    }
    .product-item {
      margin-top: 30px;
      &.last-item {
        padding-bottom: 70px;
      }
      .product-item-img {
        padding-top: 32px;
      }
      .product-item-right {
        text-align: left;
      }
    }
  }
}
</style>
